const menu        = require('../../../../../components/menu/menu')
const dtHandler   = require('../../../../../components/dt/dt-handler')

export function start( detail, htmlDt, htmlFc ){  //console.log('Menu Type 2 -> ', detail)

  const menuElem = menuBody[detail.id]

  for(let i=0; i< menuElem.length; i++){
        menuElem[i].start(detail, htmlDt, htmlFc)
  }  

  detail.html = menuElem

  detail.act = 'show'
  menu.start(detail)

}

const menuBody = {

  tabMenu: [
    {
      text: "",
      svg: `sync`,
      class: `cont icon-blue`,

      start: function () {
        this.text = "Other Expense"; //language.start('inProgress')
        this.dataDetail = `data-detail='{
                          "click": [
                              {"dest":"ripple" },
                              {"dest":"menu", "act":"hide"}, 
                              {"dest":"otherexpense", "elem":"page", "id":"otherexpense-page", "act":"show","leftnav": "leftnav-transaction-page" }
           ]}'`;
      },
    },

    { text: "line", start: function () {} }, //////////////line

    {
      text: "",
      svg: `account`,
      class: `cont icon-blue`,

      start: function () {
        this.text = "Accounts"; //language.start('inProgress')
        this.dataDetail = `data-detail='{
                          "click": [
                              {"dest":"ripple" },
                              {"dest":"menu", "act":"hide"}, 
                              {"dest":"accounts", "elem":"page", "id":"accounts-page", "act":"show","leftnav": "leftnav-transaction-page" }
           ]}'`;
      },
    },

  ],
  trMenu: [
      { text: '', 
        svg:'delete', 
        class:``,
        dataDetail:`data-detail='{
                          "click": [
                              {"dest":"ripple" },
                              {"dest":"menu", "act":"hide"}
        ]}'`,
        
        start: function(detail){  

          this.text   = 'Delete'        //language.start('inProgress')     
          this.dataDetail = `data-detail='{
                            "click": [
                              {"dest":"ripple" },
                              {"dest":"menu", "act":"hide"}, 
                              {"dest":"transaction", "elem":"fullcont", "act":"deleteEntity", "entity":"transaction", "dbid":["${detail.dbid}"] } 
           ]}'`

        }
      },
   ],

	tableOptions: [
    {
      text: '',
      svg: 'check-round',
      class: '',
      dataDetail: '',
      start: function(detail, htmlDt) {
        const ids = dtHandler.getTrChecked(htmlDt)

        if (ids.length > 0) {
          this.class = ''
          this.text = `Status (${ids.length})`
          this.dataDetail = `data-detail='{"click":[
            {"dest":"ripple"},
            {"dest":"menu","act":"hide"},
            {"dest":"transaction","elem":"dt","act":"statusDialog","dbid":[${ids}]}
          ]}'`
        } else {
          this.class = 'disabled'
          this.text = 'Status'
          this.dataDetail = ''
        }
      },
    },
  ],

  fullcontOptions: [
    {
      text: 'Delete',
      svg: 'delete',
      class: '',
      dataDetail: '',
      start: function(detail, htmlDt, htmlFc) {
        const dbid = htmlFc.fullcontHTML.getAttribute('data-dbid')
        this.dataDetail = `data-detail='{"click":[
          {"dest":"ripple"},
          {"dest":"menu","act":"hide"},
          {"dest":"transaction","elem":"fullcont","act":"deleteEntity","id":"transaction-fullcont","dbid":"${dbid}"}
        ]}'`
      },
    },
  ],

}
